/**
 * Utility helper functions for Patchwerk
 */

/**
 * Deep clone an object using JSON serialization
 * @param {any} obj - Object to clone
 * @returns {any} Deep cloned copy
 */
export function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
}
